import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter,
} from "./ui/alert-dialog";

export const ConfirmDialog = ({ open, title, description, onCancel, onConfirm, confirmLabel = "Elimina" }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent data-testid="confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <button data-testid="confirm-cancel-btn" onClick={onCancel} className="rounded-full px-4 py-2 text-sm text-muted-foreground hover:text-white">Annulla</button>
        <button data-testid="confirm-ok-btn" onClick={onConfirm} className="rounded-full bg-red-500 px-5 py-2 text-sm font-semibold text-white hover:bg-red-600">{confirmLabel}</button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
